<template>
  <full-screen-slide
    class="main-page-full-screen-slide"
    v-bind:background-image-src="image.image"
  >
    <main-text-block
      v-bind:class="textStyleClasses"
      v-bind:style="textBackgroundStyle"
      v-bind:title="image.title"
      v-bind:text="image.description"
    ></main-text-block>
  </full-screen-slide>
</template>

<script>
import FullScreenSlide from './utils/FullScreenSlide'
import MainTextBlock from './main/MainTextBlock'

export default {
  name: 'MainSlideFullScreen',
  props: {
    'image': {type: Object},
    'background-color': {
      type: String,
      default: ''
    },
    'inverse-colors': {
      type: Boolean,
      default: false
    },
    'center-text': {
      type: Boolean,
      default: true
    }
  },
  components: {FullScreenSlide, MainTextBlock},
  data: function () {
    return {}
  },
  computed: {
    textBackgroundStyle: function () {
      return this.backgroundColor
        ? { backgroundColor: this.backgroundColor } : {}
    },
    textStyleClasses: function () {
      return [
        'main-text-block',
        {'inverse-colors': this.inverseColors},
        {'center-text': this.centerText}
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .main-page-full-screen-slide {
    page-break-inside: avoid;
  }
  >>> .text-block.main-text-block {
    color: $default-link-color;
    padding: 1em;
    border-radius: 1em;

    & > h1 { color: $active-link-color; }
    & > .links-wrapper > a {
      @include framed-color-reversible-button(
        $background-color: rgba(0, 0, 0, 0.25));
    }

    &.center-text > p { text-align: center; }

    &.inverse-colors {
      color: $inverse-text-color;
      font-weight: bold;
      & > h1 { color: $inverse-text-color; }
      & > .links-wrapper > a {
        @include framed-color-reversible-button(
          $color: $inverse-text-color,
          $background-color: rgba(255, 255, 255, 0.25),
          $color-hover: $active-link-color,
          $background-color-hover: $default-background-color
        );
      }
      @media only print {
        font-weight: normal;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/MainSlideFullScreen.vue